export const ZIGZIN_PRODUCT_FREE_SHIPPING_AMOUNT = 55000;
export const ZIGZIN_PRODUCT_FREE_SHIPPING_AMOUNT_TEXT = '무료배송~990원';
export const FREE_SHIPPING_AMOUNT_TEXT = '무료배송';
